var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHashtagFill = function SvgIcHashtagFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.211 22.492a2 2 0 0 1-1.569-2.353L8.055 3.077a2 2 0 1 1 3.922.784L8.565 20.924a2 2 0 0 1-2.354 1.568M13.711 22.492a2 2 0 0 1-1.569-2.353l3.413-17.062a2 2 0 1 1 3.922.784l-3.412 17.063a2 2 0 0 1-2.354 1.568",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 8.116a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4h-14a2 2 0 0 1-2-2M2.25 15.116a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4h-14a2 2 0 0 1-2-2",
    clipRule: "evenodd"
  })));
};
export default SvgIcHashtagFill;